import React from 'react'
import BackHome from '../components/LandingPage/BackHome'

function ParishStaff(props) {
  return (
    <div className='ParishViewPage'>
        <nav className='PageHeaderBack'>
        <BackHome></BackHome>
        <h1>Parish Staff</h1>
        </nav>
        <main>
            <ul>
                <li>
                    <h2>Pastor</h2>
                    <aside>
                        <h3>Fr. Julian Ibemere</h3>
                        <h4>julian.ibemere@pastoral.org</h4>
                    </aside>
                </li>

                <li>
                    <h2>Deacons</h2>
                    <aside>
                        <h3>Tom Torson</h3>
                        <h4>931-241-0910</h4>
                        <h4>ttorson@aol.com</h4>
                    </aside>

                    <aside>
                        <h3>Jack Cheasty</h3>
                    </aside>
                </li>


                <li>
                    <h2>Parish Council Chairman</h2>
                    <aside>
                        <h3>David Tilley</h3>
                        <h4>931-237-5013</h4>
                    </aside>
                </li>

                
                <li>
                    <h2>Vice-Chair</h2>
                    <aside>
                        <h3>June Cacal</h3>
                        <h4>931-216-4600</h4>
                    </aside>
                </li>

                
                
                <li>
                    <h2>Youth/Social Concerns</h2>
                    <aside>
                        <h3>Emma Hockaday</h3>
                        <h4>270-874-7070</h4>
                    </aside>
                </li>


                                
                <li>
                    <h2>Dir. of Religious Education</h2>
                    <aside>
                        <h3>Bernadette Crisostomo</h3>
                        <h4>913-561-8449</h4>
                    </aside>
                </li>

                
                                
                <li>
                    <h2>Administrative Bookkeeper</h2>
                    <aside>
                        <h3>Dr. Elaine Agyemang Tontoh, PhD</h3>
                        <h4>347-876-2947</h4>
                    </aside>
                </li>

                                                
                <li>
                    <h2>Funds Committee Finance</h2>
                    <aside>
                        <h3>Deacon Tom Torson</h3>
                        <h4>931-241-0910</h4>
                        <h4>ttorsom@aol.com</h4>
                    </aside>
                </li>

                                                                
                <li>
                    <h2>Liturgy/Worship</h2>
                    <aside>
                        <h3>Janet Doyle</h3>
                        <h4>931-494-3562</h4>
                    </aside>
                </li>
            </ul>
        </main>


    </div>
  )
}


export default ParishStaff
